import * as React from 'react';
import { format } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Popover, PopoverContent, PopoverTrigger } from './shadcn-ui/popover';
import { Calendar } from './shadcn-ui/calendar';
import { Button } from './shadcn-ui/button';

export function DatePicker({ value, onChange, bgColor = 'bg-transparent' }) {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="flex flex-col space-y-1">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            type="button"
            className={cn(
              'w-full justify-between rounded-xl text-left font-normal',
              !value && 'text-muted-foreground',
              bgColor // <-- apply custom or default bg
            )}
          >
            {/* {value ? format(value, 'PPP') : 'Select date'} */}
            {value ? format(new Date(value), 'PPP') : 'Select date'}
            {/* <ChevronDown className="h-4 w-4 opacity-50" /> */}
            <CalendarIcon className="h-4 w-4 opacity-50" />
          </Button>
        </PopoverTrigger>

        <PopoverContent className="w-auto bg-white p-0">
          <Calendar
            mode="single"
            selected={value}
            onSelect={date => {
              onChange(date);
              setOpen(false);
            }}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
